import { api } from '@/core/api/'

const apiUrl = 'api/report';

export default {
  getInitFilterProvidersUsers() {
    return api.get(`${apiUrl}/initfiltersprovidersusers`)
  },
  getInitFilterStudentBeca() {
    return api.get(`${apiUrl}/initfiltersstudentbeca`)
  },
  getLoadedMonthsForReport(academicYearId) {
    return api.get(`${apiUrl}/months/requestservice/${academicYearId}`)
  },
  isMonthLoadedByYear(year,monthId){
    return api.get(`${apiUrl}/isrpmonthlyreportloaded/${year}/${monthId}`)
  },
  generateReportForYearAndMonth(year, month){
    return api.post(`${apiUrl}/generaterequestservicemonthlyreport/${year}/${month}`)
  },
  generateStudentVisualImpairments(id){
    return api.post(`${apiUrl}/studentvisualimpairments/${id}`)
  },
  getReferralsFromPartCToPartB(params) {
    return api.get(`${apiUrl}/referralsPartCtopartB/`,{
      params
    })
  },
  
}
